/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * CampaignInfo init translation
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { ECampaignInfoType } from '../../../../pages/PageCampaignInfo/types/campaignInfoTypes';
import { IPageCampaignInfoForType, IPageCampaignInfoTranslation } from '../../types/pages/campaignInfo';

const initPageTranslation:
    Pick<IPageCampaignInfoTranslation[ECampaignInfoType.account], 'title'> & IPageCampaignInfoForType =
    {
        card: {
            participantChosen: '',
        },
        modalApply: {
            start: {
                text: '',
                title: '',
            },
        },
        modalRemove: {
            start: {
                text: '',
                title: '',
            },
        },
        title: {
            dropFilters: '',
            label: '',
        },
    };

export const initPageCampaignInfoTranslation: IPageCampaignInfoTranslation = {
    account: {
        ...initPageTranslation,
        table: {
            accountName: { header: '', dataName: '' },
            number: { header: '', dataName: '' },
        },
    },
    subscriber: {
        ...initPageTranslation,
        validateErrors: {
            selectSubscribers: '',
        },
        table: {
            accountNumber: { header: '', dataName: '' },
            msisdn: { header: '', dataName: '' },
            name: { header: '', dataName: '' },
        },
    },
    common: {
        card: {
            btnRemove: '',
            linkDetails: '',
        },
        modalApply: {
            failure: {
                text: '',
                title: '',
            },
            success: {
                textInquiryIdEnd: '',
                textInquiryIdStart: '',
                textInquiryStart: '',
                title: '',
            },
        },
        modalRemove: {
            failure: {
                text: '',
                title: '',
            },
            start: {
                text: '',
                title: '',
            },
        },
    },
};
